import {useContext, useEffect, useState} from 'react'
import _ from 'lodash'
import WindowedSelect from 'react-windowed-select'
import {DataSourcesContext} from '@/features/data-sources'
import {IMixerChannel} from '../channel-collection'
import {defaultCutStepSize, defaultChannelValue} from '../semantic-filtering/const'
import {IFieldDescriptor} from '../..'
import './style.css'

export interface IChannelTemplateSelectorProps {
  extraOptions?: IDropdownItem[]
  onAdd: (channel: IMixerChannel) => void
}

export interface IDropdownItem extends IFieldDescriptor {
  value: IMixerChannel['value']
  isInteger?: boolean
}

export function ChannelTemplateSelector(props: IChannelTemplateSelectorProps) {
  const {extraOptions, onAdd} = props

  const {mergedItemsStats} = useContext(DataSourcesContext)
  const {categories, numbers} = mergedItemsStats

  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [dropdownOptions, setDropdownOptions] = useState<IDropdownItem[]>([])

  useEffect(() => {
    const extraOptionKeys =
      extraOptions ?
        _.chain(extraOptions)
          .map((opt) => opt.sourcePath)
          .value()
      : []
    const resCategories = _.chain(categories)
      .toPairs()
      .map(([k, v]) => {
        return _.chain(v)
          .keys()
          .map((kk) => {
            const path = `${k}["${kk}"]`
            if (_.includes(extraOptionKeys, path)) return
            const opt: IDropdownItem = {
              kind: k,
              word: kk,
              label: `${k}: ${kk}`,
              sourcePath: path,
              range: {
                min: 0,
                max: 1,
              },
              value: defaultChannelValue,
            }
            return opt
          })
          .compact()
          .value()
      })
      .flatten()
      .value()
    const resNumbers = _.chain(numbers)
      .toPairs()
      .map(([k, v]) => {
        if (_.includes(extraOptionKeys, k)) return
        const opt: IDropdownItem = {
          kind: k,
          label: `${k}`,
          sourcePath: k,
          range: v,
          value: {
            ...defaultChannelValue,
            cut: {
              min: v.min + (v.isInteger ? 0 : defaultCutStepSize),
              max: v.max,
            },
          },
        }
        if (v.isInteger !== undefined) opt.isInteger = v.isInteger
        return opt
      })
      .compact()
      .flatten()
      .value()
    const res = _.chain(resCategories)
      .concat(resNumbers)
      .concat(extraOptions || [])
      .sortBy((v) => v.label)
      .sortedUniq()
      .value()
    setDropdownOptions(res)
  }, [categories, numbers, extraOptions])

  function handleOnDropdownChanged(items: IDropdownItem[]) {
    _.forEach(items, (item) => {
      const {label, sourcePath, value} = item
      if (!(_.isString(label) && _.isString(sourcePath))) return
      const newItem: IMixerChannel = {
        descriptor: item,
        value: {
          ...defaultChannelValue,
          ...value,
        },
        isInteger: item.isInteger,
      }
      onAdd(newItem)
    })
    // setMenuIsOpen(false);
  }

  return (
    <div className='channel-template-selector'>
      <WindowedSelect
        isSearchable
        isMulti
        captureMenuScroll
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        placeholder='add adjustment...'
        menuPlacement='bottom'
        closeMenuOnSelect={false}
        windowThreshold={50}
        options={dropdownOptions}
        styles={{
          option: (provided, state) => ({
            ...provided,
            borderBottom: '1px dotted pink',
            color: state.isFocused ? 'white' : 'black',
            background: state.isFocused ? '#ff099a' : 'transparent',
          }),
        }}
        value={[]}
        onChange={(props) => handleOnDropdownChanged(props as IDropdownItem[])}
      />
    </div>
  )
}
